import { useState } from 'react';

interface DuplicateModalState {
  isOpen: boolean;
  entityType: 'deposit' | 'section' | 'horizon' | 'bed' | null;
  entityData: any | null;
  parentIds: {
    fieldUuid?: string;
    depositUuid?: string;
    areaUuid?: string;
    horizonUuid?: string;
  };
}

export const useDuplicateModal = () => {
  const [duplicateModal, setDuplicateModal] = useState<DuplicateModalState>({
    isOpen: false,
    entityType: null,
    entityData: null,
    parentIds: {}
  });

  const [duplicateName, setDuplicateName] = useState<string>('');
  const [deepCopy, setDeepCopy] = useState<boolean>(false);
  const [targetParentId, setTargetParentId] = useState<string>('');

  const openDuplicateModal = (
    entityType: 'deposit' | 'section' | 'horizon' | 'bed',
    entityData: any,
    parentIds: {
      fieldUuid?: string;
      depositUuid?: string;
      areaUuid?: string;
      horizonUuid?: string;
    }
  ) => {
    console.log('📂 Открытие модалки дублирования:', {
      entityType,
      entityData,
      parentIds,
      entityName: entityData?.name,
      entityCode: entityData?.code,
      entityUuid: entityData?.uuid
    });

    const baseName = entityType === 'horizon' 
      ? entityData.code 
      : entityData.name;
    
    // Убираем существующее "(копия)" если есть
    const cleanBaseName = baseName.replace(/ \(копия\)$/, '');
    const newName = `${cleanBaseName} (копия)`;
    
    console.log('📝 Создано имя:', { baseName, cleanBaseName, newName });
    
    setDuplicateName(newName);
    setDeepCopy(false);
    
    // Устанавливаем текущую родительскую сущность как выбранную по умолчанию
    let defaultId = '';
    if (entityType === 'deposit' && parentIds.fieldUuid) {
      defaultId = parentIds.fieldUuid;
    } else if (entityType === 'section' && parentIds.depositUuid) {
      defaultId = parentIds.depositUuid;
    } else if (entityType === 'horizon' && parentIds.areaUuid) {
      defaultId = parentIds.areaUuid;
    } else if (entityType === 'bed' && parentIds.horizonUuid) {
      defaultId = parentIds.horizonUuid;
    }
    
    console.log('📍 ID по умолчанию:', defaultId);
    setTargetParentId(defaultId);
    
    setDuplicateModal({
      isOpen: true,
      entityType,
      entityData,
      parentIds
    });
  };

  const closeDuplicateModal = () => {
    setDuplicateModal({
      isOpen: false,
      entityType: null,
      entityData: null,
      parentIds: {}
    });
    setDuplicateName('');
    setDeepCopy(false);
    setTargetParentId('');
  };

  return {
    duplicateModal,
    duplicateName,
    deepCopy,
    targetParentId,
    setDuplicateName,
    setDeepCopy,
    setTargetParentId,
    openDuplicateModal,
    closeDuplicateModal
  };
};